import React from "react";
import { useNavigate } from "react-router-dom";

const ViewTransactionLogs: React.FC = () => {
    const navigate = useNavigate();

    const transaction = {
        transactionId: "TXN-982341",
        amount: "AED 1,250.00",
        gateway: "Stripe",
        reference: "STRP-8839201",
        date: "18 Mar 2025, 11:45 AM",
        status: "Completed",

        from: {
            id: "USR-1021",
            name: "TechHub Electronics",
            type: "Vendor",
        },

        to: {
            id: "PLT-001",
            name: "Platform Wallet",
            type: "Platform",
        },

        transactionFor: "Order Commission",

        orderDetails: {
            orderId: "ORD-12345",
            bookingId: null, // use if booking-based
            category: "Electronics",
            itemName: "iPhone 14 Pro",
            quantity: 1,
            orderDate: "16 Mar 2025",
        },
    };

    return (
        <>
            <div className="view_order_page">
                {/* HEADER */}
                <div className="main_title">
                    <h1>View Transaction Logs</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        <button onClick={() => navigate("/financial-reports")}>
                            Transaction Logs
                        </button>{" "}
                        - View Transaction
                    </p>
                </div>

                {/* TRANSACTION SUMMARY */}
                <div className="cards view_page">
                    <h3>Transaction Summary</h3>

                    <div className="gap_p">
                        <div className="w_33">
                            <h6>Transaction ID</h6>
                            <p>{transaction.transactionId}</p>
                        </div>

                        <div className="w_33">
                            <h6>Amount</h6>
                            <p>{transaction.amount}</p>
                        </div>

                        <div className="w_33">
                            <h6>Status</h6>
                            <p className="text_success">{transaction.status}</p>
                        </div>

                        <div className="w_33">
                            <h6>Payment Gateway</h6>
                            <p>{transaction.gateway}</p>
                        </div>

                        <div className="w_33">
                            <h6>Reference</h6>
                            <p>{transaction.reference}</p>
                        </div>

                        <div className="w_33">
                            <h6>Date</h6>
                            <p>{transaction.date}</p>
                        </div>

                        <div className="w_33">
                            <h6>Transaction For</h6>
                            <p>{transaction.transactionFor}</p>
                        </div>
                    </div>
                </div>

                {/* FROM / TO */}
                <div className="cards view_page">
                    <h3>Transaction Parties</h3>

                    <div className="gap_p">
                        <div className="w_33">
                            <h6>From ID</h6>
                            <p>{transaction.from.id}</p>
                        </div>

                        <div className="w_33">
                            <h6>From Name</h6>
                            <p>{transaction.from.name}</p>
                        </div>

                        <div className="w_33">
                            <h6>From Type</h6>
                            <p>{transaction.from.type}</p>
                        </div>

                        <div className="w_33">
                            <h6>To ID</h6>
                            <p>{transaction.to.id}</p>
                        </div>

                        <div className="w_33">
                            <h6>To Name</h6>
                            <p>{transaction.to.name}</p>
                        </div>

                        <div className="w_33">
                            <h6>To Type</h6>
                            <p>{transaction.to.type}</p>
                        </div>
                    </div>
                </div>

                {/* ORDER / BOOKING DETAILS */}
                <div className="cards view_page">
                    <h3>Order / Booking Details</h3>

                    <div className="gap_p">
                        <div className="w_33">
                            <h6>Order ID</h6>
                            <p>{transaction.orderDetails.orderId}</p>
                        </div>

                        {transaction.orderDetails.bookingId && (
                            <div className="w_33">
                                <h6>Booking ID</h6>
                                <p>{transaction.orderDetails.bookingId}</p>
                            </div>
                        )}

                        <div className="w_33">
                            <h6>Category</h6>
                            <p>{transaction.orderDetails.category}</p>
                        </div>

                        <div className="w_33">
                            <h6>Item / Service</h6>
                            <p>{transaction.orderDetails.itemName}</p>
                        </div>

                        <div className="w_33">
                            <h6>Quantity</h6>
                            <p>{transaction.orderDetails.quantity}</p>
                        </div>

                        <div className="w_33">
                            <h6>Order Date</h6>
                            <p>{transaction.orderDetails.orderDate}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewTransactionLogs;
